import React, {useEffect, useState} from "react";
import {mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {DocumentsBatch, RefpadoDocument} from "../../types";
import {QRFooter} from "../qr_footer/QRFooter";
import {selectedDocument} from "./index";

import {RefregfResponse} from "../../types/refpregf";
import {AvailableDocuments} from "./AvailableDocuments";
import {ErrorDocDialog} from "../../components/error_doc_dialog/ErrorDocDialog";

export const RefregfDoc: React.FC<{ documents: DocumentsBatch , withVersions?: boolean }> = ({
                                                                                                 documents,
                                                                                                 withVersions = true
                                                                                             }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<RefregfResponse>(
            selectedDocument.document.document as RefregfResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as RefregfResponse);
    }, [selectedDocument.document.version]);


    const title = `Справка о совместной регистрации по адресу № ${mayBe(doc.refNumber) || 'б/н'}`;

    const subTitle = `Выдана заявителю:`;

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };

    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.personInfo.lastName)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.personInfo.firstName)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.personInfo.midName)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.personInfo.birthdate) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={!!document ? getDocument(doc.personInfo.document) : '-'}
                        />
                    </div>

                    <DocTitle subtitle={'Заявитель зарегистрирован по месту жительства'} title={''}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Адрес регистрации" bold value={mayBe(doc.personInfo.regAddress)}/>
                    </div>
                </div>
                {
                        withVersions &&  documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }
                <div className="col-span-12 md:col-span-8 md:order-last">
                    {(doc?.matesConst?.length > 0) &&
                            <>
                                <DocTitle title={''}
                                          subtitle={'В жилом помещении с заявителем зарегистрированы по месту жительства:'}/>
                                {doc.matesConst.map((mate, idx) =>
                                        <div className="pl-3 pb-5 mt-5 bottom-line" key={idx}>
                                            <DocRow title="Фамилия" bold value={mayBe(mate.lastName)}/>
                                            <DocRow title="Имя" bold value={mayBe(mate.firstName)}/>
                                            <DocRow title="Отчество" bold value={mayBe(mate.midName)}/>
                                            <DocRow title="Дата рождения" bold
                                                    value={mayBe(mate.birthDate) || '***'}/>
                                            <DocRow title="Дата регистрации" bold
                                                    value={mayBe(mate.regDate) || '***'}/>
                                        </div>
                                )}
                            </>
                    }
                    {(doc?.matesTemp?.length > 0) &&
                            <>
                                <DocTitle title={''}
                                          subtitle={'В жилом помещении с заявителем зарегистрированы по месту пребывания:'}/>
                                {
                                    doc.matesTemp.map((mate, idx) =>
                                            <div className="pl-3 pb-5 mt-5 bottom-line" key={idx}>
                                                <DocRow title="Фамилия" bold value={mayBe(mate.lastName)}/>
                                                <DocRow title="Имя" bold value={mayBe(mate.firstName)}/>
                                                <DocRow title="Отчество" bold value={mayBe(mate.midName)}/>
                                                <DocRow title="Дата рождения" bold
                                                        value={mayBe(mate.birthDate) || '***'}/>
                                                <DocRow title="Дата регистрации" bold
                                                        value={mayBe(mate.regDate) || '***'}/>
                                            </div>
                                    )
                                }
                            </>
                    }

                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.refDate}
                              mfcInfoName={doc.mfcInfo.name}
                              mfcUserName={doc.mfcUser.name}
                    />
                </div>

            </>
    );
};
